import { Component } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { MuiScrollbarService } from '../../scrollbar';
import { MuiAnimationTiming } from '../../utility';

const outStyle = style({opacity: 0, right: '2rem'});
const inStyle = style({opacity: 1, right: '3rem'});

const scrollBtnAnimation = trigger('scrollBtnAnimation', [
  transition(':enter', [
    outStyle,
    animate(MuiAnimationTiming.EASE_OUT, inStyle)
  ]),
  transition(':leave', [
    inStyle,
    animate(MuiAnimationTiming.EASE_OUT, outStyle)
  ])
]);

@Component({
  selector: 'mui-hero-scroll-fab, button[mui-hero-scroll-fab]',
  templateUrl: './mui-hero-scroll-fab.component.html',
  styleUrls: ['./mui-hero-scroll-fab.component.scss'],
  animations: [scrollBtnAnimation]
})
export class MuiHeroScrollFab {
  scrolledToBottom = false;

  constructor(private muiScrollbarService: MuiScrollbarService) {
    this.muiScrollbarService.scrolledToBottom.subscribe(bottom => {
      this.scrolledToBottom = bottom;
    });
  }

  onClick() {
    this.muiScrollbarService.scrollToBottom();
  }
}
